export const RECEIVE_USER = 'RECEIVE_USER';
export const RECEIVE_STUDENT = 'RECEIVE_STUDENT';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
